import { Outlet } from 'react-router-dom'

import { F0Alert, F0Box } from '@factorialco/f0-react'

import { BulkEmailChangePagePolicyDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const BulkEmailChangePage = () => {
  const { company, access } = useCurrentSession()
  const { has_dev_bulk_email_change, loadingFeatures } = useFeatures(['dev_bulk_email_change'])
  const { data, loading: loadingPolicy } = useQuery(BulkEmailChangePagePolicyDocument)

  const canBulkEditEmail = !!data?.authentication._policies.bulkEmailChange.can
  const canImportResources = !!data?.universalImporter._policies.importResources.can
  const locale = access.locale

  return (
    <ResponsivePage.Body
      authorized={has_dev_bulk_email_change && canBulkEditEmail && canImportResources}
      loading={loadingFeatures || loadingPolicy}
      error={null}
    >
      <F0Box display="flex" gap="xl" flexDirection="column">
        <F0Box display="flex" gap="lg" flexDirection="column">
          <F0Alert
            variant="info"
            title={i18n.t('security_settings.bulk_email_change.info_banner.title')}
            description={i18n.t('security_settings.bulk_email_change.info_banner.description')}
          />
          <F0Alert
            variant="warning"
            title={i18n.t('security_settings.bulk_email_change.verified_domain_banner.title')}
            description={i18n.t(
              'security_settings.bulk_email_change.verified_domain_banner.description'
            )}
          />
        </F0Box>
        <NuvoImporter importType="bulk_email_change" locale={locale} companyId={company.id} />
        <Outlet />
      </F0Box>
    </ResponsivePage.Body>
  )
}

export default BulkEmailChangePage
